import {createRouter, createWebHashHistory} from 'vue-router'
import main from '../views/main.vue'

const routes = [
    {
        path: '/',
        name: 'main',
        component: main
    },
    {
        path: '/buy',
        name: 'buy',
        component: () => import(/* webpackChunkName: "buy" */ '../views/buy.vue')
    },
    {
        path: '/info',
        name: 'info',
        component: () => import(/* webpackChunkName: "buy" */ '../views/info.vue')
    },
    {
        path: '/buySuccess',
        name: 'buySuccess',
        component: () => import(/* webpackChunkName: "buy" */ '../views/buySuccess.vue')
    },
    {
        path: '/noticeList',
        name: 'noticeList',
        component: () => import(/* webpackChunkName: "noticeList" */ '../views/noticeList.vue')
    },
    {
        path: '/courseList',
        name: 'courseList',
        component: () => import(/* webpackChunkName: "courseList" */ '../views/courseList.vue')
    },
    {
        path: '/ppList',
        name: 'ppList',
        component: () => import(/* webpackChunkName: "ppList" */ '../views/ppList.vue')
    },
    {
        path: '/buyList',
        name: 'buyList',
        component: () => import(/* webpackChunkName: "buyList" */ '../views/buyList.vue')
    },

    {
        path: '/carList',
        name: 'carList',
        component: () => import(/* webpackChunkName: "carList" */ '../views/carList.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
